import React, { useEffect } from 'react';
import Notifications from './notifications'
import _ from 'lodash'
import { useNavigation } from '@react-navigation/native'
import { messageConstants } from 'utils/constants/message-constants'
import { AppRoutes } from 'navigations/app-routes'
import { View } from 'react-native'

// Notifications handle
if( Notifications !== null ) {
	Notifications.setNotificationHandler({
		handleNotification: async () => {
			return (
				{
					shouldShowAlert: true,
					shouldPlaySound: false,
					shouldSetBadge: false,
				}
			);
		},
	});
}

const PushNotifications = () => {
	
	const navigation = useNavigation();
	
	const onResponse = ( response ) => {
		const requestContent = _.get( response, ['notification', 'request', 'content'], {} );
		if( !_.isEmpty( requestContent ) ) {
			let messageGuid = _.get( requestContent, ['data', 'guid'], null );
			if( messageGuid === null ) {
				messageGuid = _.get( requestContent, ['data', 'body', 'guid'], null );
			}
			
			if( messageGuid !== null ) {
				navigation.navigate( AppRoutes.MORE_INBOX_VIEW, {
					guid: messageGuid,
					type: messageConstants.PUSH_NOTIFICATION,
				})
			}
		}
	}
	
	useEffect( () => {
		if( Notifications === null ) {
			return;
		}

		const subscription = Notifications.addNotificationResponseReceivedListener( onResponse.bind( this ) );
		
		return () => {
			subscription.remove();
		};
	}, [] )
	
	return (
		<View />
	)
}

export default PushNotifications
